const FromArr = [{
	title: "年度：",
	inputtype: "select",
	inputflag: true,
	fontSize: 14,
	color: "#333333",
	lableheight: 20,
	X: false,
	types: "",
	placeholder: "请选择",
	width: 192,
	height: 32,
	disabled: false,
	marginLeft: 52,
	marginTop: 15,
	displayVal: "inline-block",
	fontWeightVal: 500,
	options: []
}, {
	title: "产品线：",
	inputtype: "select",
	inputflag: true,
	fontSize: 14,
	color: "#333333",
	lableheight: 20,
	X: false,
	types: "",
	placeholder: "请选择",
	width: 192,
	height: 32,
	disabled: false,
	marginLeft: 100,
	marginTop: 15,
	displayVal: "inline-block",
	fontWeightVal: 50,
	options: []
}, {
	title: "Level3：",
	inputtype: "select",
	inputflag: true,
	fontSize: 14,
	color: "#333333",
	lableheight: 20,
	X: false,
	types: "",
	placeholder: "请选择",
	width: 192,
	height: 32,
	disabled: false,
	marginLeft: 50,
	marginTop: 15,
	displayVal: "inline-block",
	fontWeightVal: 500,
	options: []
}, {
	title: "小区经理：",
	inputtype: "input",
	inputflag: true,
	fontSize: 14,
	color: "#333333",
	lableheight: 20,
	X: false,
	types: "text",
	placeholder: "请输入",
	width: 182,
	height: 32,
	disabled: false,
	marginLeft: 25,
	marginTop: 30,
	displayVal: "inline-block",
	fontWeightVal: 500
}]
export default FromArr;
